import { SiteConfig } from './SiteConfig';

export const priceFormatter = (price: number, currency: string) => {
  const { locale } = SiteConfig.getConfig();
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(price);
};
